module.exports = __webpack_public_path__ + "img/blockshape_t.1c6bc4db.png";